import React, { useEffect, useState } from "react";
import "./Mid-section-Mobile.scss"; // CSS file for custom styles

//components
import InformationCard from "./Card";
import QuickLinksCard from "./QuickLinksCard";
import PaymentTable from "./RecentPaymentsCards";
import PayWindowModal from "../../Payments/Mobile-and-Tablet/PayWindowModal";

//icons
import { FaHome } from "react-icons/fa";
import { MdWaterDrop } from "react-icons/md";
import { FaClock } from "react-icons/fa";
import { FaSpinner } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import { LiaFileInvoiceSolid } from "react-icons/lia";

//imports for user data
import { useSelector } from "react-redux";

const MiddleSectionOverview = () => {
  //data fetched
  const { profile } = useSelector((state) => state.landlordslice);

  //invoices pending data
  const latestInvoice = profile?.tenant_details?.unpaidInvoices;
  console.log("latestInvoice", latestInvoice);
  const cardData1 = {
    Title: "Invoices Pending",
    fields: ["rent", "water", "arrears", "garbage"],
    rent: latestInvoice?.rent || "0",
    water: latestInvoice?.water || "0",
    arrears: latestInvoice?.arrears || "0",
    // serviceCharge: latestInvoice.serviceCharge || "0",
    unpaidDeposit: latestInvoice?.unpaidDeposit || "0",
    garbage: latestInvoice?.garbage || "0",
    totalAmount:
      (latestInvoice?.rent || 0) +
      (latestInvoice?.water || 0) +
      (latestInvoice?.arrears || 0) +
      // (latestInvoice.serviceCharge || 0) +
      (latestInvoice?.unpaidDeposit || 0) +
      (latestInvoice?.garbage || 0),
  };

  //invoices paid data
  let latestPayment = profile?.tenant_details?.payments?.[0];

  let totalRent = 0;
  let totalWater = 0;
  let totalArrears = 0;
  let totalServiceCharge = 0;
  let totalUnpaidDeposit = 0;
  let totalGarbage = 0;
  let totalLateFee = 0;
  let totalAmount = 0;

  profile?.tenant_details?.payments?.forEach((payment) => {
    totalRent += payment?.rent || 0;
    totalWater += payment?.water_bill || 0;
    totalArrears += payment?.arrears || 0;
    totalServiceCharge += payment?.serviceCharge || 0;
    totalUnpaidDeposit += payment?.deposit || 0;
    totalGarbage += payment?.garbage_charge || 0;
    totalLateFee += payment?.lateFee || 0;
    totalAmount += payment?.amount || 0;
  });

  latestPayment = {
    rent: totalRent,
    water_bill: totalWater,
    arrears: totalArrears,
    serviceCharge: totalServiceCharge,
    deposit: totalUnpaidDeposit,
    garbage_charge: totalGarbage,
    lateFee: totalLateFee,
    amount: totalAmount,
  };

  const cardData2 = {
    Title: "Invoices Paid",
    fields: ["rent", "water", "arrears", "garbage"],
    rent: latestPayment?.rent || "0",
    water: latestPayment?.water_bill || "0",
    arrears: latestPayment?.arrears || "0",
    serviceCharge: latestPayment.serviceCharge || "0",
    unpaidDeposit: latestPayment?.deposit || "0",
    garbage: latestPayment?.garbage_charge || "0",
    totalAmount: latestPayment?.amount || "0",
  };

  //total data
  const total = cardData1?.totalAmount + cardData2?.totalAmount || 0;
  useEffect(() => {
    console.log("total for phone updataed ", total);
    console.log("cardData1", cardData1?.totalAmount);
    console.log("cardData2", cardData2?.totalAmount);
  }, [total]);

  const [seeMoreClicked, setSeeMoreClicked] = useState(false);
  // const[seeMoreQuickLinksClicked, setSeeMoreQuickLinksClicked] = useState(false);

  const [showPay, setShowPay] = useState(false);
  const [fieldToShow, setFieldToShow] = useState(null);

  useEffect(() => {
    console.log("showPay", showPay);
    if (!showPay) {
      setFieldToShow(null);
    }
  }, [showPay]);

  return (
    <div className="mid-section-mobile">
      <div className="title-container">
        <div className="title">Your reports</div>
        <button
          className="more"
          onClick={() => {
            setSeeMoreClicked(!seeMoreClicked);
          }}
        >
          {seeMoreClicked ? "Hide" : "See more"}
        </button>
      </div>
      <div className="cards-container">
        <InformationCard
          titleText={"Invoices Pending"}
          contentInCard={`${cardData1.totalAmount}`}
          percentageContent={`${(
            (cardData1?.totalAmount / total) *
            100
          ).toFixed(0)}`}
        />
        <InformationCard
          titleText={"Invoices Paid"}
          contentInCard={`${cardData2.totalAmount}`}
          percentageContent={`${(
            (cardData2?.totalAmount / total) *
            100
          ).toFixed(0)}`}
        />
        {seeMoreClicked && (
          <>
            <InformationCard
              titleText={"Unpaid deposit"}
              setMarginTop={true}
              contentInCard={`${cardData1.unpaidDeposit}`}
              percentageContent={`${(
                (cardData1?.unpaidDeposit /
                  (Number(cardData1.unpaidDeposit) +
                    Number(cardData2.unpaidDeposit))) *
                  100 || 0
              ).toFixed(0)}`}
            />
            <InformationCard
              titleText={"Arrears"}
              setMarginTop={true}
              contentInCard={`${cardData1.arrears}`}
              percentageContent={`${(
                (cardData1?.arrears / total) *
                100
              ).toFixed(0)}`}
            />
          </>
        )}
      </div>

      <div className="quick-links-container">
        {/* <div className="title-container">
        <div className="title">Quick Payments</div>
        <button className="more" onClick={() => {
          setSeeMoreQuickLinksClicked(!seeMoreQuickLinksClicked);
        }}>See more</button>
        </div>  */}

        <div className="quick-links-card-container">
          <QuickLinksCard
            title={"Rent"}
            Icon={FaHome}
            setShowPay={setShowPay}
            setFieldToShow={setFieldToShow}
          />
          <QuickLinksCard
            title={"Water"}
            Icon={MdWaterDrop}
            setShowPay={setShowPay}
            setFieldToShow={setFieldToShow}
          />
          <QuickLinksCard
            title={"Arrears"}
            Icon={FaClock}
            setShowPay={setShowPay}
            setFieldToShow={setFieldToShow}
          />
          <QuickLinksCard
            setMarginTop={true}
            title={"Service Charge"}
            Icon={LiaFileInvoiceSolid}
            setShowPay={setShowPay}
            setFieldToShow={setFieldToShow}
          />
          <QuickLinksCard
            setMarginTop={true}
            title={"Unpaid Deposit"}
            Icon={FaSpinner}
            setShowPay={setShowPay}
            setFieldToShow={setFieldToShow}
          />
          <QuickLinksCard
            setMarginTop={true}
            title={"Garbage"}
            Icon={FaTrash}
            setShowPay={setShowPay}
            setFieldToShow={setFieldToShow}
          />
        </div>
      </div>
      <div className="transactions-container">
        <div className="title-container" style={{ marginBottom: "0px" }}>
          <div className="title">Latest Transactions</div>
        </div>
        <PaymentTable />
      </div>

      {showPay && (
        <>
          <div className="modal">
            <PayWindowModal setShowPay={setShowPay} fieldToShow={fieldToShow} />
          </div>
        </>
      )}
    </div>
  );
};

export default MiddleSectionOverview;
